import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import './DetailsRow.css';

library.add(faExternalLinkAlt);

const formatPercent = (number) => {
  return number !== null ? parseFloat(number * 100).toFixed(2) + '%' : '-';
};

const LinkCell = ({ url, iconColor }) => (
  <td colrow="Website" className="textCenter">
    <a className="tickerLink" href={url} target="_new">
      <FontAwesomeIcon style={{ color: iconColor }} icon="external-link-alt" />
    </a>
  </td>
);

const TextCell = () => (
  <td colrow="Website" className="textCenter">
    -
  </td>
);

const UnderlyingModel = ({ underlyingPerformances, wtRegion }) => {
  return (
    <>
      {underlyingPerformances.map((fund, b) => {
        const url = fund.fundPageURL ? fund.fundPageURL : fund.msUrl;
        const urlFilings =
          fund.type === 'WTETF'
            ? 'https://www.wisdomtree.com/resource-library/prospectus-regulatory-reports'
            : 'https://doc.morningstar.com/docdetail.aspx?clientid=schwab&key=84b36f1bf3830e07&cusip=' +
              fund.cusip;
        return (
          <tr>
            <td colrow="Ticker" className="textLeft">
              {fund.ticker}
            </td>
            {fund.type !== 'BLEND' ? (
              <LinkCell url={url} iconColor="#050139" />
            ) : (
              <TextCell />
            )}
            {fund.type !== 'BLEND' ? (
              <LinkCell url={urlFilings} iconColor="#050139" />
            ) : (
              <TextCell />
            )}
            <td colrow="Inception Date" className="textCenter">
              {new Date(fund.inceptionDate).toLocaleDateString()}
            </td>
            <td colrow="Gross Expense Ratio" className="textCenter">
              {(fund.expenseRatioGross * 100).toFixed(2) + '%'}
            </td>
            <td colrow="Net Expense Ratio" className="textCenter">
              {(fund.expenseRatio * 100).toFixed(2) + '%'}
            </td>
            {wtRegion === 'US' && (
              <React.Fragment>
                <td
                  colrow="30-Day SEC Yield, Subsidized"
                  className="textCenter"
                >
                  {formatPercent(
                    fund.stdPerformance.slice(-1)[0].sec30DayYieldSub
                  )}
                </td>
                <td
                  colrow="30-Day SEC Yield, Unsubsidized"
                  className="textCenter"
                >
                  {formatPercent(
                    fund.stdPerformance.slice(-1)[0].sec30DayYieldUnSub
                  )}
                </td>
              </React.Fragment>
            )}
            <td colrow="Notes" className="textLeft">
              {fund.expenseNotes}
            </td>
          </tr>
        );
      })}
    </>
  );
};

const UnderlyingDetails = ({ fundData, wtRegion }) => {
  if (fundData.type === 'WTMOD') {
    return (
      <UnderlyingModel
        underlyingPerformances={fundData.underlyingPerformances}
        wtRegion={wtRegion}
      />
    );
  }
  return null;
};

const DetailsRow = ({ fund, wtRegion }) => {
  if (fund.stdPerformance === null) {
    return null;
  }

  const url = fund.fundPageURL ? fund.fundPageURL : fund.msUrl;
  const urlFilings =
    fund.type === 'WTETF'
      ? 'https://www.wisdomtree.com/resource-library/prospectus-regulatory-reports'
      : 'https://doc.morningstar.com/docdetail.aspx?clientid=schwab&key=84b36f1bf3830e07&cusip=' +
        fund.cusip;

  const rowStyle = fund.underlyingPerformances
    ? { backgroundColor: 'lightgray', fontWeight: 'bold' }
    : {};

  return (
    <>
      <tr className="greyline" style={rowStyle}>
        <td colrow="Ticker" className="textLeft">
          {fund.ticker.toUpperCase()}
          {fund.type === 'WTMOD' ? ':' : ''}
          {fund.type === 'WTMOD' && (
            <p style={{ fontSize: 'small', fontStyle: 'italic' }}>Model</p>
          )}
        </td>
        {fund.type !== 'BLEND' ? (
          <LinkCell url={url} iconColor="#050139" />
        ) : (
          <TextCell />
        )}
        {fund.type !== 'BLEND' ? (
          <LinkCell url={urlFilings} iconColor="#050139" />
        ) : (
          <TextCell />
        )}
        <td colrow="Inception Date" className="textCenter">
          {new Date(fund.inceptionDate).toLocaleDateString()}
        </td>
        <td colrow="Gross Expense Ratio" className="textCenter">
          {(fund.expenseRatioGross * 100).toFixed(2) + '%'}
        </td>
        <td colrow="Net Expense Ratio" className="textCenter">
          {(fund.expenseRatio * 100).toFixed(2) + '%'}
        </td>
        {wtRegion === 'US' && (
          <React.Fragment>
            <td colrow="30-Day SEC Yield, Subsidized" className="textCenter">
              {formatPercent(fund.stdPerformance.slice(-1)[0].sec30DayYieldSub)}
            </td>
            <td colrow="30-Day SEC Yield, Unsubsidized" className="textCenter">
              {formatPercent(
                fund.stdPerformance.slice(-1)[0].sec30DayYieldUnSub
              )}
            </td>
          </React.Fragment>
        )}
        <td colrow="Notes" className="textLeft">
          {fund.expenseNotes}
        </td>
      </tr>
      <UnderlyingDetails fundData={fund} wtRegion={wtRegion} />
    </>
  );
};

export default DetailsRow;
